import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { Driver } from '../types/models/user';

export const useUserBridgeStore = defineStore('userBridge', () => {
	const vuex = useStore();

	const user = computed(() => vuex.state.auth.user);
	const checkPermisions = computed(() => {
		return (permission: string) => {
			return vuex.getters['auth/checkPermission'](permission);
		};
	});
	return {
		checkPermisions,
		user,
	};
});
